module.exports = __webpack_public_path__ + "3c9859df721718e8e3764dfcc302e390.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/owl-store-dollars.png
// module id = 2569
// module chunks = 0